import { render, staticRenderFns } from "./ProdukHome.vue?vue&type=template&id=21b256ea&"
import script from "./ProdukHome.vue?vue&type=script&lang=js&"
export * from "./ProdukHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports